import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { requiresRole: 'hr' }  // hr và các role cao hơn có thể truy cập
      },
      {
        path: 'shifts',
        name: 'Shifts',
        component: () => import('../views/shifts/ShiftList.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền quản lý ca làm việc
      },
      {
        path: 'shifts/new',
        name: 'NewShift',
        component: () => import('../views/shifts/ShiftForm.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền tạo ca làm việc mới
      },
      {
        path: 'shifts/:id/edit',
        name: 'EditShift',
        component: () => import('../views/shifts/ShiftForm.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền sửa ca làm việc
      },
      {
        path: 'personnel',
        name: 'Personnel',
        component: () => import('../views/personnel/PersonnelList.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền xem danh sách nhân viên
      },
      {
        path: 'personnel/create',
        name: 'CreatePersonnel',
        component: () => import('../views/personnel/PersonnelEdit.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền thêm nhân viên
      },
      {
        path: 'personnel/:id',
        name: 'EditPersonnel',
        component: () => import('../views/personnel/PersonnelEdit.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền sửa nhân viên
      },
      {
        path: 'attendance/locations',
        name: 'AttendanceLocations',
        component: () => import('../views/attendance/AttendanceLocationList.vue'),
        meta: { requiresRole: 'admin' }
      },
      {
        path: 'attendance/locations/new',
        name: 'NewAttendanceLocation',
        component: () => import('../views/attendance/LocationPersonnelForm.vue'),
        meta: { requiresRole: 'admin' }
      },
      {
        path: 'attendance/locations/:id/edit',
        name: 'EditAttendanceLocation',
        component: () => import('../views/attendance/LocationPersonnelForm.vue'),
        meta: { requiresRole: 'admin' }
      },
      {
        path: 'attendance',
        name: 'Attendance',
        component: () => import('../views/attendance/AttendanceList.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền xem chấm công
      },
      {
        path: 'attendance/:id',
        name: 'AttendanceDetail',
        component: () => import('../views/attendance/AttendanceDetail.vue'),
        meta: { requiresRole: 'manager' }  // manager trở lên có quyền xem chi tiết chấm công
      },
      {
        path: 'hrm-sync',
        name: 'HRMSync',
        component: () => import('../views/hrm/HRMSync.vue'),
        meta: { requiresRole: 'admin' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('../views/settings/Settings.vue'),
        meta: { requiresRole: 'admin' }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']

  // Cho phép truy cập các route không yêu cầu xác thực
  if (!to.meta.requiresAuth) {
    // Nếu đã đăng nhập và cố truy cập login page
    if (to.name === 'Login' && isAuthenticated) {
      return next({ name: 'Dashboard' })
    }
    return next()
  }

  // Kiểm tra xác thực cho các route yêu cầu đăng nhập
  if (!isAuthenticated) {
    return next({
      name: 'Login',
      query: { redirect: to.fullPath }
    })
  }

  // Kiểm tra quyền truy cập
  if (to.meta.requiresRole) {
    const hasAccess = store.getters['auth/hasAccess'](to.meta.requiresRole)
    if (!hasAccess) {
      // Nếu không có quyền truy cập, chuyển về trang chủ hoặc trang 403
      return next({ name: 'NotFound' })
    }
  }

  next()
})

export default router